import { render, staticRenderFns } from "./FeatureView.vue?vue&type=template&id=1b42149a&scoped=true&"
import script from "./FeatureView.vue?vue&type=script&lang=js&"
export * from "./FeatureView.vue?vue&type=script&lang=js&"
import style0 from "./FeatureView.vue?vue&type=style&index=0&id=1b42149a&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b42149a",
  null
  
)

export default component.exports